<template>
  <div class="q-pa-sm flex">
    <div class="flex">
      <LogoSoluzion />
      <div v-if="title" class="text-h6 q-pl-md">{{ title }}</div>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import LogoSoluzion from './LogoSoluzion.vue';

defineProps<{ title?: string }>()
</script>

<style scoped>
div.q-pa-sm {
  max-width: 460px;
  height: 58px;
  margin: 0 auto;
  align-items: center;
  justify-items: stretch;
  box-sizing: border-box;
}

div.q-pa-sm>div {
  margin-right: auto;
}
</style>
